import { render, staticRenderFns } from "./PausarAtendimento.vue?vue&type=template&id=c2045df6&"
import script from "./PausarAtendimento.vue?vue&type=script&lang=js&"
export * from "./PausarAtendimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports